


















/* Created- 15 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";
import { IArticle } from "../../../Models/ArticleModels/article";

@Component(
	{
		name: "SimpleArticleView",
		components: {}
	})
export default class SimpleArticleView extends Vue {
	@Prop() private article: IArticle;
	@Prop() private path: string;
	private getImage(): string {
		if (this.article.images === null) {
			return "https://dashboard.partica.online/app2/img/no-image.jpg";
		} else {
			return this.article.getFeaturedImage(this.$store.state.config.thumburl, 600);
		}
	}
	private preview(article: IArticle) {
		this.$emit("partica-event", {
			action: eParticaAction.ARTICLE_PREVIEW,
			item: article
		} as ParticaEvent);
	}
	private edit(article: IArticle) {
		this.$emit("partica-event", {
			action: eParticaAction.ARTICLE_EDIT,
			item: article
		} as ParticaEvent);
	}
	private licence(article: IArticle) {
		this.$emit("partica-event", {
			action: eParticaAction.SELECT_ARTICLE_LICENCE,
			item: article
		} as ParticaEvent);
	}
}
